// extracted by mini-css-extract-plugin
export default {"editButton":"onetimeDeduction_editButton__S0ztA","TableBody":"onetimeDeduction_TableBody__YMFS7","deleteButton":"onetimeDeduction_deleteButton__X6v9d"};